import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderFooterWrapper = ({
  children,
  borderStyleProps
}) => {
  return /*#__PURE__*/_jsx(Text, {
    typography: "detail-100",
    as: "div",
    children: /*#__PURE__*/_jsx(Flex, Object.assign({
      backgroundColor: "fill-surface-recessed",
      paddingInlineStart: "400",
      paddingInlineEnd: "200",
      paddingBlockStart: "200",
      paddingBlockEnd: "200",
      alignItems: "start",
      overflowY: "hidden"
    }, borderStyleProps, {
      children: children
    }))
  });
};